import { assoc, compose, map, pathOr, pick } from 'ramda'

import { cleanFieldValuesRequest } from '../../../../utils/helpers/fields'
import { formatAddressForApi } from '../../../../utils/helpers/address'
import { formatApiDate } from '../../../../utils/helpers/date'

const cleanEvents = serviceOrder => {
  if (!!serviceOrder.id) return serviceOrder
  return assoc('events', [{ statusId: 1, eventDate: formatApiDate(new Date()) }], serviceOrder)
}

export const cleanRequest = map(
  compose(
    pick([
      'id',
      'parentId',
      'parentDependent',
      'name',
      'userId',
      'checklistId',
      'placeId',
      'assetId',
      'scheduling',
      'priorityId',
      'address',
      'description',
      'documents',
      'groupId',
      'userGroupIds',
      'fieldValues',
      'events'
    ]),

    item => assoc('scheduling', formatApiDate(item.scheduling), item),
    item => (!!item.description ? item : assoc('description', null, item)),
    item => assoc('address', !!item.address?.search ? formatAddressForApi(item.address) : null, item),
    item => assoc('priorityId', pathOr(null, ['priority', 'id'], item), item),
    item => assoc('checklistId', pathOr(null, ['checklist', 'id'], item), item),
    item => assoc('assetId', pathOr(null, ['asset', 'id'], item), item),
    item =>
      assoc(
        'placeId',
        (v => (v == null ? null : parseInt(v, 10)))(pathOr(null, ['place', 'id'], item)),
        item
      ),
    item => assoc('userId', item.userOrGroup?.__typename === 'User' ? item.userOrGroup?.id : null, item),
    item =>
      assoc(
        'groupId',
        item.userOrGroup?.__typename === 'UserGroup' && !Array.isArray(item.userOrGroup) ? item.userOrGroup?.id : null,
        item
      ),
    item =>
      assoc(
        'userGroupIds',
        Array.isArray(item.userOrGroup) && item?.userOrGroup?.every(group => group?.__typename === 'UserGroup')
          ? item.userOrGroup.map(group => group.id)
          : null,
        item
      ),
    item => assoc('documents', map(pick(['id', 'description']), item.documents || []), item),
    item => assoc('fieldValues', cleanFieldValuesRequest(item.fieldValues || []), item),
    cleanEvents
  )
)
